module.exports = __webpack_public_path__ + "img/kendall.5a0e395b.jpg";